import axios from "axios";
import Auth from "./authService";
import toast from "react-hot-toast";

// Debug environment variables
console.log("=== Environment Variables Debug ===");
console.log("process.env.MERCHANT:", process.env.MERCHANT);
console.log("process.env.REACT_APP_MERCHANT:", process.env.REACT_APP_MERCHANT);
console.log("process.env.NODE_ENV:", process.env.NODE_ENV);
console.log(
  "All REACT_APP_ environment variables:",
  Object.keys(process.env).filter((key) => key.startsWith("REACT_APP_"))
);
console.log(
  "All environment variables containing 'MERCHANT':",
  Object.keys(process.env).filter((key) => key.includes("MERCHANT"))
);
console.log(
  "Total environment variables count:",
  Object.keys(process.env).length
);
console.log("===================================");

axios.interceptors.request.use((config) => {
  config.headers.Authorization = `bearer ${Auth.getJwt()}`;
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    toast.dismiss();

    // temp solution for cors origin when calling publish endpoint
    // (not recommended, you should fix it from next js app)
    if (!error.config.url.includes("/api/revalidate?secret"))
      toast.error(`Error : ${error.response?.data?.message || error}`, {
        hideProgressBar: true,
        position: "top-right",
      });

    // handle status [401, 405] errors
    if (error.response?.status === 401 || error.response?.status === 405) {
      Auth.LogOut();
    }

    return Promise.reject(error);
  }
);

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common.Accept = "application/json";
axios.defaults.headers.common["Accept-Language"] = "en";

// Try both environment variable names and log the result
const merchantId = process.env.REACT_APP_MERCHANT;
axios.defaults.headers.common["MerchantId"] = merchantId;

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

export default axios;
